import React, { Fragment } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { ReactComponent as Spinner } from "assets/icons/spinner.svg";
import { paginationStyles } from "store/results/paginationStyles";
import { Button } from "elements/Button/Button";
import "./Pagination.scss";

const LoadMoreButton = props => {
  return (
    <Button
      className="load-more-button"
      onClick={props.loadMore}
      isDisabled={props.isLoadingMore}
      render={() => (
        <Fragment>
          <span className="button__text">{!props.isLoadingMore ? 'Load more' : 'Loading'}</span>
          {props.isLoadingMore && (
          <div className="button__icon">
            <Spinner />
          </div>
          )}
        </Fragment>
      )}
    />
  );
};

const separator = '...';

const pagination = (currentPage, nrOfPages) => {
  const minPages = 5;
  const delta = 1;

  if(nrOfPages <= 1)
    return [];

  const pages = [];

  for(let i = 1; i <= nrOfPages; i++){
    if(i === 1)      
      pages.push(i);
    else if(i === nrOfPages) {
      pages.push(i);
    }
    else {
      if(i >= currentPage - delta && i <= currentPage + delta){
        pages.push(i);
      }
      else if(i < minPages && i - currentPage < minPages - 1 && i >= currentPage - delta){
        pages.push(i);
      }
      else if(i > nrOfPages - minPages + 1  && currentPage > nrOfPages - minPages && i <= currentPage  + delta){
        pages.push(i);
      }
      else if(pages[pages.length - 1] !== separator){
        pages.push(separator);
      }
    }
  }

  return pages;
}

const PaginationLinks = props => {
  
  const getLinkStyle = page => cx("z-pagination__link", { "is-selected": page.isCurrent });

  const pages = pagination(props.currentPage, props.totalPages).map(page => ({
    number: page,
    isCurrent: page === props.currentPage,
  }));

  return (
    <ol className="z-pagination__links">
      {pages.map(page => (
        <li key={page.number} className={getLinkStyle(page)}>
          {page.number === separator &&  <span className="z-pagination__separator">{separator}</span>}
          {page.number !== separator && 
            <Button
              className="z-pagination__button"
              text={page.number.toString()}
              isDisabled={page.isCurrent}
              onClick={() => props.updatePage({ page: page.number })}
            />
          }
        </li>
      ))}
    </ol>
  );
};

const Pagination = props => {
  return (
    <div className="z-pagination">
      {props.style === paginationStyles.buttons && props.totalPages > props.currentPage && (
        <LoadMoreButton {...props} />
      )}

      {props.style === paginationStyles.numbers && props.totalPages > 1 && (
        <PaginationLinks {...props} />
      )}
    </div>
  );
};

Pagination.propTypes = {
  style: PropTypes.oneOf([paginationStyles.buttons, paginationStyles.numbers]).isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
};

export default Pagination;
